<ion-item color="light" (click)="fileInput.click()">
  <ion-label>{{ this.translocoService.translate(props.label) }}<ion-text *ngIf="props.required" color="danger"> *</ion-text></ion-label>
  <ion-button (click)="fileInput.click(); $event.stopPropagation();" [fill]="'outline'">
    {{ 'FORMLY.FILE.CHOOSE' | transloco }}
  </ion-button>
  
  <input 
    type="file" 
    #fileInput 
    class="hidden"
    [attr.accept]="props.accept || null" 
    (change)="onFileChange($event)"
  />
</ion-item>

<ion-item color="light" *ngIf="displayFileName" (click)="fileInput.click()">
  <ion-note 
    class="p-0 m-0"
  >
    {{ displayFileName }}
  </ion-note>
</ion-item>

<ion-item color="light" *ngIf="showError" (click)="fileInput.click()">
  <ion-note
    color="danger"
    class="text-sm"
  >
    {{ errorMessage }}
  </ion-note>
</ion-item>